(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Deviceful", [], factory);
	else if(typeof exports === 'object')
		exports["Deviceful"] = factory();
	else
		root["Deviceful"] = factory();
})(window, function() {
return 